(function () {
  'use strict';
  if (window.__bskPdp) return;
  window.__bskPdp = true;

  var DATA = null;
  try { DATA = JSON.parse(document.querySelector('[data-bsk-product]').textContent); } catch (e) { DATA = null; }

  var DESC = {
    'hard': 'Slim, light hard shell with a sharp printed finish.',
    'stride 2.0': 'Our signature Stride 2.0 build, made for selected models.',
    'glossy single layer': 'Glossy printed shell in a slim single-layer build.',
    'glossy double layer': 'Glossy print with an extra inner layer for more drop protection.',
    'glass': 'Shiny tempered-glass back with soft protective edges.'
  };

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function ls(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function money(c) { return '₹' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function design(title) {
    return String(title || '').replace(/\s*(Stride 2\.0 Phone Case|Stride 2\.0 Case|Phone Case|Mobile Cover|Case)\s*/i, ' ').replace(/\s+\|\s+/, ' | ').replace(/\s+/g, ' ').trim();
  }
  function mainForm() { return document.querySelector('form[id^="product-form-main-"]'); }
  function currentVariant() {
    if (!DATA) return null;
    var f = mainForm(), inp = f && f.querySelector('[name="id"]');
    var id = inp ? +inp.value : 0;
    for (var i = 0; i < DATA.variants.length; i++) if (DATA.variants[i].id === id) return DATA.variants[i];
    return DATA.variants[0] || null;
  }
  function chosenModel() {
    var p = document.querySelector('[data-bsk-pdp]');
    return (p && p.getAttribute('data-value')) || '';
  }
  function isCaseTypeLabel(lab) { return !!(window.BSK_TYPES || {})[norm(lab.textContent)]; }

  /* ---------- Choose your case: case-type swatches become cards ---------- */
  function caseCards() {
    if (!DATA) return;
    var sws = document.querySelectorAll('.product-form__variants .block-swatch');
    var list = null;
    sws.forEach(function (sw) {
      var lab = sw.querySelector('label');
      if (!lab || !isCaseTypeLabel(lab)) return;
      list = sw.parentElement;
      if (sw.querySelector('.bsk-ct__img')) return;
      var name = norm(lab.textContent), price = null, img = null;
      DATA.variants.forEach(function (v) {
        var has = v.options.some(function (o) { return norm(o) === name; });
        if (!has) return;
        if (price === null || v.price < price) price = v.price;
        if (!img && v.image) img = v.image;
      });
      var key = /glass/.test(name) ? 'glass' : /double|tough/.test(name) ? 'tough' : /hard|single/.test(name) ? 'hard' : '';
      img = (key && DATA.ct && DATA.ct[key]) || img || DATA.image;
      sw.classList.add('bsk-ct');
      if (price !== null) lab.setAttribute('data-bsk-price', money(price));
      sw.insertAdjacentHTML('beforeend',
        '<span class="bsk-ct__img" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="bsk-ct__chk" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#111"/><path d="M7 12.5l3.2 3L17 9" fill="none" stroke="#fff" stroke-width="2.2"/></svg></span>');
    });
    if (!list) { strideTile(); return; }
    list.classList.add('bsk-ct-list');
    var opt = list.closest('.product-form__option-selector') || list.parentElement;
    if (opt) {
      opt.classList.add('bsk-ct-opt');
      var nm = opt.querySelector('.product-form__option-name');
      if (nm && !/choose/i.test(nm.textContent)) setText(nm, 'Choose your case:');
    }
    if (!list.nextElementSibling || !list.nextElementSibling.classList.contains('bsk-ct-more')) {
      var box = document.createElement('div');
      box.className = 'bsk-ct-more';
      box.innerHTML = '<button type="button" class="bsk-ct-learn" aria-expanded="false">Learn more</button><div class="bsk-ct-info" hidden></div>';
      list.parentNode.insertBefore(box, list.nextSibling);
    }
    var info = list.nextElementSibling.querySelector('.bsk-ct-info');
    var html = '';
    list.querySelectorAll('.block-swatch.bsk-ct').forEach(function (sw) {
      if (sw.style.display === 'none') return;
      var n = sw.querySelector('label').textContent.trim();
      var d = DESC[norm(n)];
      if (d) html += '<p><strong>' + esc(n) + '</strong> ' + esc(d) + '</p>';
    });
    if (info.innerHTML !== html) info.innerHTML = html;
  }
  function strideTile() {
    if (!/stride/i.test(DATA.title) || document.querySelector('.bsk-ct-static')) return;
    var anchor = document.querySelector('[data-bsk-more]') || document.querySelector('[data-bsk-pdp]');
    if (!anchor) return;
    var v = DATA.variants[0], img = (DATA.ct && DATA.ct.stride) || DATA.image;
    var box = document.createElement('div');
    box.className = 'bsk-ct-static';
    box.innerHTML = '<p class="bsk-ct-static__label">Choose your case: <span>Stride 2.0</span></p>' +
      '<div class="bsk-ct-list"><div class="block-swatch bsk-ct is-on"><span class="bsk-ct__img"><img src="' + esc(img) + '" alt="" loading="lazy"></span>' +
      '<span class="block-swatch__item" data-bsk-price="' + (v ? money(v.price) : '') + '">Stride 2.0 Case</span>' +
      '<span class="bsk-ct__chk" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#111"/><path d="M7 12.5l3.2 3L17 9" fill="none" stroke="#fff" stroke-width="2.2"/></svg></span></div></div>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.bsk-ct-learn');
    if (!b) return;
    try { caseCards(); } catch (x) {}
    var info = b.nextElementSibling;
    info.hidden = !info.hidden;
    b.setAttribute('aria-expanded', String(!info.hidden));
    b.textContent = info.hidden ? 'Learn more' : 'Show less';
  });

  /* ---------- Add to cart - ₹price (main + sticky) ---------- */
  function atcLabels() {
    var v = currentVariant();
    if (!v || !v.available) return;
    var txt = 'Add to cart - ' + money(v.price);
    var html = esc(txt) + (v.cmp > v.price ? ' <s class="bsk-atc-cmp">' + money(v.cmp) + '</s>' : '');
    var f = mainForm();
    var btns = [];
    if (f) {
      f.querySelectorAll('.product-form__add-button').forEach(function (b) { btns.push(b); });
      document.querySelectorAll('button.product-form__add-button[form="' + f.id + '"]').forEach(function (b) { if (btns.indexOf(b) < 0) btns.push(b); });
    }
    btns.forEach(function (b) {
      if (b.disabled) return;
      if (b.getAttribute('data-button-content') !== html) b.setAttribute('data-button-content', html);
      var span = b.querySelector('.loader-button__text');
      var el = span || (!b.querySelector('*:not(s)') ? b : null);
      if (el && el.innerHTML !== html) el.innerHTML = html;
    });
  }

  /* ---------- Desktop sticky bar: "Design - Model Case" + case type ---------- */
  function sticky() {
    if (!DATA) return;
    var title = document.querySelector('.product-sticky-form__title');
    if (!title) return;
    var m = chosenModel();
    setText(title, m ? design(DATA.title) + ' - ' + m + ' Case' : DATA.title);
    var v = currentVariant();
    var sub = v ? v.options.filter(function (o) { return o !== 'Default Title'; }).join(' / ') : '';
    var info = title.closest('.product-sticky-form__info');
    if (!info) return;
    var el = info.querySelector('.bsk-sticky-sub');
    if (!sub) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('span'); el.className = 'bsk-sticky-sub'; info.insertBefore(el, info.firstChild); }
    setText(el, sub);
  }

  /* ---------- Accessories carousel ---------- */
  var AIR_ALL = ['AirPods Pro 3', 'AirPods Pro 2', 'AirPods Pro', 'AirPods 5', 'AirPods 4', 'AirPods 3', 'AirPods 2', 'AirPods 1'];
  function airKey(s) {
    var n = norm(s).replace(/^_+/, '').replace(/apple\s*/, '');
    var pro = /pro/.test(n);
    var g = (n.match(/\((\d)(st|nd|rd|th) generation\)/) || n.match(/(\d)\s*$/) || [])[1] || (pro ? '1' : '');
    return (pro ? 'pro' : 'std') + (g || '');
  }
  function airLabel(key) {
    var pro = key.indexOf('pro') === 0, g = key.replace(/\D/g, '');
    if (pro) return g === '1' ? 'AirPods Pro' : 'AirPods Pro ' + g;
    return 'AirPods ' + g;
  }
  function isIphone14Plus(m) {
    var n = norm(m);
    var x = n.match(/iphone\s*(\d+)/);
    return (x && +x[1] >= 14) || /iphone\s*air/.test(n);
  }
  function airCard(form) {
    var data = form.__bskv;
    if (!data) { try { data = form.__bskv = JSON.parse(form.querySelector('[data-bsk-acc-variants]').textContent); } catch (e) { return; } }
    var devSel = form.querySelector('[data-bsk-acc-airsel]');
    var devIdx = devSel ? +devSel.getAttribute('data-bsk-acc-opt') : -1;
    if (devSel && !devSel.__bsk) {
      devSel.__bsk = true;
      /* Every AirPods model in stock is offered; models without their own variant are sent as a Device note */
      var have = {};
      Array.prototype.forEach.call(devSel.options, function (o) { have[airKey(o.value)] = o.value; });
      devSel.innerHTML = AIR_ALL.map(function (name) {
        var k = airKey(name), v = have[k] || ('__' + name);
        return '<option value="' + esc(v) + '">' + esc(name) + '</option>';
      }).join('');
      var saved = ls('bsk_airpods');
      if (saved) Array.prototype.forEach.call(devSel.options, function (o) { if (airKey(o.value) === airKey(saved)) devSel.value = o.value; });
    }
    var sels = form.querySelectorAll('[data-bsk-acc-opt]');
    var want = [];
    sels.forEach(function (s) { want[+s.getAttribute('data-bsk-acc-opt')] = s.value; });
    var noVariant = devSel && devSel.value.indexOf('__') === 0;
    var cands = data.filter(function (v) { return want.every(function (w, i) { return (noVariant && i === devIdx) || v.o[i] === w; }); });
    var match = cands.filter(function (v) { return v.a; })[0] || cands[0];
    var vid = form.querySelector('[data-bsk-acc-vid]'), btn = form.querySelector('.bsk-acc2__add');
    if (match && vid.value !== String(match.id)) vid.value = match.id;
    var ok = !!(match && match.a);
    if (btn.disabled === ok) btn.disabled = !ok;
    var dev = devSel ? airLabel(airKey(devSel.value)) : '';
    var prop = form.querySelector('[data-bsk-acc-airprop]');
    if (devSel && !prop) { prop = document.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[Device]'; prop.setAttribute('data-bsk-acc-airprop', ''); form.appendChild(prop); }
    if (prop && prop.value !== dev) prop.value = dev;
    var line = form.querySelector('[data-bsk-acc-air]');
    setText(line, devSel ? 'For ' + dev + (ok ? '' : ' · sold out') : (ok ? '' : 'Sold out'));
  }
  function accessories() {
    var m = ls('bsk_model');
    document.querySelectorAll('[data-bsk-acc-dev]').forEach(function (p) {
      setText(p, m ? 'For ' + m : 'Select your phone model ›');
      p.classList.toggle('is-empty', !m);
      var inp = p.parentNode.querySelector('[data-bsk-acc-devinput]');
      if (inp && inp.value !== m) inp.value = m;
    });
    document.querySelectorAll('[data-bsk-acc-sp]').forEach(function (c) {
      var show = !!m && isIphone14Plus(m);
      if (c.hidden === show) c.hidden = !show;
    });
    document.querySelectorAll('.bsk-acc2__form').forEach(function (f) { if (f.querySelector('[data-bsk-acc-variants]')) airCard(f); });
    document.querySelectorAll('[data-bsk-acc2]').forEach(function (w) {
      var track = w.querySelector('[data-bsk-acc2-track]'), dots = w.querySelector('[data-bsk-acc2-dots]');
      var cards = Array.prototype.filter.call(track.children, function (c) { return !c.hidden; });
      w.hidden = !cards.length;
      if (!w.__bsk) {
        w.__bsk = true;
        dots.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          var vis = Array.prototype.filter.call(track.children, function (c) { return !c.hidden; });
          var idx = Array.prototype.indexOf.call(dots.children, b);
          if (vis[idx]) track.scrollTo({ left: vis[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        var tick = false;
        track.addEventListener('scroll', function () {
          if (tick) return; tick = true;
          requestAnimationFrame(function () {
            tick = false;
            var first = Array.prototype.filter.call(track.children, function (c) { return !c.hidden; })[0];
            if (!first) return;
            var idx = Math.round(track.scrollLeft / (first.offsetWidth + 12));
            for (var j = 0; j < dots.children.length; j++) dots.children[j].classList.toggle('is-active', j === idx);
          });
        }, { passive: true });
      }
      if (dots.children.length !== cards.length) {
        var h = '';
        for (var i = 0; i < cards.length; i++) h += '<button type="button" aria-label="Accessory ' + (i + 1) + '"' + (i ? '' : ' class="is-active"') + '></button>';
        dots.innerHTML = h;
        track.scrollLeft = 0;
      }
      if (dots.hidden !== (cards.length < 2)) dots.hidden = cards.length < 2;
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-bsk-acc-opt]')) return;
    if (t.hasAttribute('data-bsk-acc-airsel') && t.value) {
      try { localStorage.setItem('bsk_airpods', t.options[t.selectedIndex].text); } catch (x) {}
    }
    schedule();
  });
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-bsk-acc-dev].is-empty');
    if (d && window.BSKModel) window.BSKModel.open('full');
  });
  /* Wallets: always carry the phone model into the cart */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('bsk-acc2__form')) return;
    var inp = f.querySelector('[data-bsk-acc-devinput]');
    if (!inp) return;
    inp.value = inp.value || ls('bsk_model');
    if (!inp.value) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (window.BSKModel) window.BSKModel.open('full');
    }
  }, true);

  /* ---------- More designs: scroll progress bar ---------- */
  function moreDesigns() {
    document.querySelectorAll('[data-bsk-more]').forEach(function (w) {
      if (w.__bsk) return;
      w.__bsk = true;
      var track = w.querySelector('[data-bsk-more-track]'), bar = w.querySelector('[data-bsk-more-bar]');
      function upd() {
        var sw = track.scrollWidth, cw = track.clientWidth;
        if (sw <= cw + 2) { bar.parentNode.style.visibility = 'hidden'; return; }
        bar.parentNode.style.visibility = '';
        bar.style.width = (cw / sw * 100) + '%';
        bar.style.left = (track.scrollLeft / sw * 100) + '%';
      }
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  var queued = false;
  function run() {
    queued = false;
    try { moreDesigns(); } catch (e) {}
    try { caseCards(); } catch (e) {}
    try { atcLabels(); } catch (e) {}
    try { sticky(); } catch (e) {}
    try { accessories(); } catch (e) {}
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(run); } }
  document.addEventListener('change', function () { setTimeout(schedule, 60); });
  window.addEventListener('storage', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value'] });
  run();
})();
